import React from 'react';
import ReactDOM from 'react-dom';

import Autoplay from 'embla-carousel-autoplay';
import globals from 'Js/common/globals';
import ProAnalytics from 'Js/common/pro-analytics';
import StartSalesBanner from './main/components/StartSalesBanner';
import { initEmbla } from './common/initEmbla';

onDomReady(() => {
    const bannerBlock = document.getElementById(
        'start-page-start-sales-banner--btn-wrapper'
    );
    const sliderBlock = document.getElementById('main-media-slider');
    const productsBlock = document.getElementById('popular-products-slider');

    const containerCatalogList = document.querySelector(
        '#external-catalog-list'
    );

    if (sliderBlock) {
        const options = { loop: true, align: 'start' };
        const plugins = [Autoplay({ playOnInit: true, delay: 30000 })];
        initEmbla(sliderBlock, options, plugins);
    }

    if (bannerBlock) {
        ReactDOM.render(
            React.createElement(StartSalesBanner, bannerBlock),
            bannerBlock
        );
    }

    if (productsBlock) {
        const options = { loop: true, align: 'start' };

        const onSlideClick = e => {
            // Карточка, на которую навешан обработчик
            const slide = e.currentTarget;
            // Элемент, по которому кликнули
            const { target } = e;
            const { categoryId, brandId, partNumber, href } = slide.dataset;

            if (target.closest('a, button')) {
                ProAnalytics.pushEvent('main:topPartItemClicked', {
                    isProSeller: Boolean(globals.user.isActivePro),
                    partCategory: +categoryId,
                    partNumber,
                    brandId: +brandId,
                    pathType: 'mainPage',
                    path: href
                });
            }

            if (target.closest('button')) {
                window.location.href = href;
            }
        };

        initEmbla(productsBlock, options, null, onSlideClick);
    }

    if (containerCatalogList) {
        document.addEventListener('click', ({ target }) => {
            if (target.hasAttribute('data-link')) {
                const link = target.querySelector(
                    '.external-catalog__list-item-link'
                ).href;
                if (link) {
                    window.location.href = link;
                }
            }
        });
    }

    if (window.location.href.includes('qrCodeModal=true')) {
        const stoQrCodeModalContainer = document.createElement('div');

        import('./main/App').then(app => {
            ReactDOM.render(
                React.createElement(app.default, {
                    container: stoQrCodeModalContainer
                }),
                stoQrCodeModalContainer
            );
        });
    }

    if (window.location.href.includes('stoConnect=true')) {
        const stoModalContainer = document.createElement('div');
        import('Js/partslist/features/sto-connection/StoConnectionApp').then(
            app => {
                ReactDOM.render(
                    React.createElement(app.default, {
                        container: stoModalContainer
                    }),
                    stoModalContainer
                );
            }
        );
    }
});
